import { lyfeAuthTheme } from "../theme/LyfeAuthTheme";
import { LyfePalette, lyfeTheme } from "../theme/lyfeTheme";
import { newLyfeTheme } from "../theme/newLyfeTheme";
import { AppType } from "../theme/types";

export default function getTheme(app: AppType) {
	switch (app) {
		case "platform":
			return {
				...lyfeTheme,
				palette: {
					...lyfeTheme.palette,
					primary: { ...(lyfeTheme.palette as LyfePalette).platform.primary },
					secondary: { ...(lyfeTheme.palette as LyfePalette).platform.secondary },
				},
			};
		case "platform-new":
			return {
				...newLyfeTheme,
			};
		case "platform-auth":
			return {
				...lyfeAuthTheme,
			};
		default:
			return lyfeTheme;
	}
}
